import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { Icon } from '@panel/commons/lib/Icon/Icon';

const PostingSkeleton = () => {
  return (
    <Post>
      <UpperSection>
        <Icon name='unCheckbox' size={100} margin='0px' />
        <Avatar />
        <LeftSideInfo>
          <InfoArea>
            <Line width={109} mBottom={18} />
            <Line width={252} mBottom={12} />
            <Line width={109} mBottom='0' />
          </InfoArea>
          <InfoArea center>
            <Line width={64} mBottom={13} />
            <Quality />
          </InfoArea>
        </LeftSideInfo>
        <Metrics>
          <UpperMetrics>
            <Line width={112} marginLeft={22} mBottom='0' />
            <Line width={249} height={29} mBottom='0' />
          </UpperMetrics>
          <BottomMetrics>
            <InfoArea>
              <Line width={79} mBottom={5} />
              <Line width={60} mBottom='0' />
            </InfoArea>
            <InfoArea>
              <Line width={79} mBottom={5} />
              <Line width={60} mBottom='0' />
            </InfoArea>
            <InfoArea>
              <Line width={79} mBottom={5} />
              <Line width={60} mBottom='0' />
            </InfoArea>
          </BottomMetrics>
        </Metrics>
      </UpperSection>
      <BottomSection>
        <Line width={511} mBottom='0' />
        <Line width={137} mBottom='0' />
      </BottomSection>
    </Post>
  );
};

const baseColor = '#f6f6f7';
const shineColor = '#fff';
const animationDuration = '1.6s';

const BackgroundGradient = css`
  background-image: ${`linear-gradient(90deg, ${baseColor} 0px, ${shineColor} 40px, ${baseColor} 80px)`};
  background-size: 600px;
`;

const ShineLines = keyframes`
  0% { background-position: -100px };
  40% { background-position: 200px};
  100% { background-position: 200px};
`;

const ShineAvatar = keyframes`
  0% { background-position: ${`-100px`}};
  40% { background-position: ${`140px`}};
  100% { background-position: ${`140px`}};
`;

const animationAvatar = css`
  ${ShineAvatar} ${animationDuration} infinite linear;
`;

const animationLine = css`
  ${ShineLines} ${animationDuration} infinite linear;
`;

const Post = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 168px;
  border-radius: 8px;
  box-shadow: 5px 4px 32px 2px #c4c4c433;
  border: 1px solid ${select('middleGray')};
`;

const UpperSection = styled.div`
  height: 127px;
  width: 100%;
  border-bottom: 0.8px solid ${select('grayMedium')};
  display: flex;
  align-items: center;
  padding: 18px 16px 16px 16px;
`;

const Avatar = styled.div`
  background-color: #ccc;
  ${BackgroundGradient};
  animation: ${animationAvatar};
  margin-right: 24px;
  height: 94px;
  width: 108px;
  border-radius: 8px;
  margin-left: 16px;
`;

const Quality = styled.div`
  background-color: #ccc;
  ${BackgroundGradient};
  animation: ${animationAvatar};
  height: 60px;
  width: 60px;
  border-radius: 50%;
`;

const LeftSideInfo = styled.div`
  height: 100%;
  width: 420px;
  padding: 5px 16px;
  border-right: 0.8px solid ${select('grayMedium')};
  display: flex;
  justify-content: space-between;
`;

const Metrics = styled.div`
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const UpperMetrics = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -2px;
  margin-bottom: 19px;
`;

const BottomMetrics = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 34px;
  padding-right: 28px;
`;

const InfoArea = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: ${({ center }) => center && 'center'};
`;

const BottomSection = styled.div`
  width: 100%;
  padding: 12px 16px 0 47px;
  display: flex;
  justify-content: space-between;
`;

export const Line = styled.div`
  float: left;
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => (height ? `${height}px` : '16px')};
  margin-bottom: ${({ mBottom }) => (mBottom ? `${mBottom}px` : '8px')};
  border-radius: 8px;
  ${BackgroundGradient};
  animation: ${animationLine};
  margin-right: ${({ marginRight }) => marginRight && `${marginRight}px`};
  margin-left: ${({ marginLeft }) => marginLeft && `${marginLeft}px`};
  position: ${({ position }) => position && position};
  top: ${({ top }) => top && top};
  bottom: ${({ bottom }) => bottom && bottom};
  right: ${({ right }) => right && right};
  left: ${({ left }) => left && left};
`;

export default PostingSkeleton;
